import { useLocation } from "react-router-dom";
import Router from "./router/Router";
import SessionModal from "./components/SessionModal";
import { EventFormProvider } from "./context/EventFormContext";
import { useDispatch, useSelector } from "react-redux";
import { useRef, useEffect } from "react";
import { ONBOARDING_BASE_PATH } from "./features/onboarding/steps/registry";
import {
  loadAccountContract,
  selectContractLoaded,
} from "./features/capabilities/capabilitySlice";

const AppContent = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const path = location.pathname;
  const profileStep = useSelector((state) => state.profileSlice?.profileStep);
  const contractLoaded = useSelector(selectContractLoaded);
  const containerRef = useRef(null);

  const isEventRoute = path.includes("/events/");
  const isOnboardingRoute =
    path === ONBOARDING_BASE_PATH ||
    path.startsWith(`${ONBOARDING_BASE_PATH}/`);

  // Load what this member may do, once per session (ECH-288).
  //
  // Here rather than in each sign-in path: there are three ways a session starts
  // — login, finishing onboarding, and a token refresh — plus a page reload,
  // which has no sign-in event at all. One effect on the shell covers them all.
  //
  // Keyed on the path so it re-checks after navigation, which is when a member
  // who just signed in first reaches a guarded route.
  useEffect(() => {
    if (!contractLoaded && localStorage.getItem("token")) {
      dispatch(loadAccountContract());
    }
  }, [contractLoaded, dispatch, path]);

  // AUTO SCROLL TO TOP ON STEP CHANGE
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [profileStep]);

  const Content = (
    <>
      <Router />
      <SessionModal />
    </>
  );

  return (
    <div
      ref={containerRef}
      className="bg-alice-blue"
      // Explicit base color: the bg-alice-blue class has no CSS definition,
      // so without this, areas below content-hugging Background boxes show
      // the body color instead of the app background.
      style={{
        height: isOnboardingRoute ? "100dvh" : "100vh",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        backgroundColor: "#f5f9fc",
      }}
    >
      {isEventRoute ? (
        <EventFormProvider>{Content}</EventFormProvider>
      ) : (
        Content
      )}
    </div>
  );
};

export default AppContent;
